module.exports = __webpack_public_path__ + "static/media/sam-kirkby.80c06a64.jpeg";